(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CustomerTypeDetailController', CustomerTypeDetailController);

    CustomerTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'CustomerType'];

    function CustomerTypeDetailController($scope, $rootScope, $stateParams, entity, CustomerType) {
        var vm = this;
        vm.customerType = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:customerTypeUpdate', function(event, result) {
            vm.customerType = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
